// extracted by mini-css-extract-plugin
module.exports = {"text":"selection_text__I2lOx","item":"selection_item__fOoNk","label":"selection_label__19xiM","reset":"selection_reset__3x2Ie","option":"selection_option__1cnBf"};